import fetch from 'auth/FetchInterceptor'

const cobrancaUsuarioService = {}

cobrancaUsuarioService.all = function () {
  return fetch({
    url: '/cobranca-usuario/all',
    method: 'get',
    headers: {
        'Content-Type': 'application/json',
      },
  })
}

cobrancaUsuarioService.paginado = function ({ situacao, page = 0, size = 10 } = {}) {
  const params = { page, size }
  if (situacao) params.situacao = situacao
  return fetch({
    url: '/cobranca-usuario',
    method: 'get',
    params,
  })
}

cobrancaUsuarioService.atrasoAtual = function () {
  return fetch({
    url: '/cobranca-usuario/atraso-atual',
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export default cobrancaUsuarioService
